__turbopack_context__.v({
  "table": "_2PU67W_table",
});
